<script setup>
import { ref, onMounted } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { rulesUrl } from "@/utils/provider";

const storeSettings = useSettingsStore();

const faqActive = ref({});
const dataFaq = ref({});
const dataFaqList = ref([]);
const offset = ref(0);
const limit = ref(4);

const formatAnswer = (text) => {
	if (!text) return "";
	const escaped = text.replace(/(?:\r\n|\r|\n)/g, "<br>").replace("правил по ссылке", `<a href="${rulesUrl}" target="_blank" rel="noopener noreferrer">ссылке</a>`);
	return escaped;
};

const openFaqItem = (index) => {
	const newActiveState = {};
	for (let i = 0; i < dataFaqList.value.length; i++) {
		newActiveState[i] = i === index ? !faqActive.value[index] : false;
	}
	faqActive.value = newActiveState;
};

onMounted(async () => {
	dataFaq.value = await storeSettings.getFaq();
	dataFaqList.value = dataFaq.value.data.results;
});
</script>
<template>
	<section class="faq" id="faq">
		<div class="container">
			<h2 class="faq__title title2 --red">FAQ</h2>
			<div class="faq__container">
				<ul v-if="dataFaq" class="faq__list">
					<li :class="['faq__item', { active: faqActive[index] }]" v-for="(faq, index) in dataFaqList" :key="index" @click="openFaqItem(index)">
						<div class="faq__question">
							<span>{{ faq.question }}</span>
							<div class="faq__btn">
								<svg width="24" height="24"><use href="#chevron-down"></use></svg>
							</div>
						</div>
						<div class="faq__answer">
							<div style="min-height: 0" v-html="formatAnswer(faq.answer)"></div>
						</div>
					</li>
				</ul>
				<div class="faq__feedback">
					<h2 class="title2 --red">Остались вопросы?</h2>
					<div class="faq__link">Напишите нам на <a href="mailto:info@couturier-gourmet.ru" target="_blank" rel="noopener noreferrer">info@couturier-gourmet.ru</a></div>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.faq {
	position: relative;
	padding: 8rem 0 10rem;

	@media (max-width: vars.$x480) {
		padding: 54px 0 62px;
	}
}

.faq__title {
	text-align: center;
	margin-bottom: 2rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 12px;
	}
}

.faq__container {
	display: grid;
	gap: 10rem;
	max-width: 740px;
	margin: 0 auto;
	@media (max-width: vars.$m) {
		max-width: 100%;
	}
	@media (max-width: vars.$x480) {
		gap: 40px;
	}
}

.faq__list {
}
.faq__item {
	padding: 3rem 2.6rem;
	border-bottom: 1px solid #d6d6d6;
	transition: var(--transition) ease-in;
	@media (max-width: vars.$xx) {
		padding: 20px 0;
	}
	&.active {
		.faq__question {
			span {
				color: var(--red);
			}
		}
		.faq__btn {
			svg {
				transform: rotateX(-180deg);
			}
		}
		.faq__answer {
			grid-template-rows: 1fr;
			padding-top: 1.2rem;
			@media (max-width: vars.$x480) {
			}
		}
	}
}
.faq__question {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	font-weight: 400;
	font-size: 2rem;
	line-height: 130%;
	cursor: pointer;
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
}
.faq__btn {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	svg {
		width: 2.4rem;
		height: 2.4rem;
		stroke: hsla(240, 100%, 0%, 1);
		transition: var(--transition) ease-in;
		@media (max-width: vars.$x480) {
			width: 1.6rem;
			height: 1.6rem;
		}
	}
}
.faq__answer {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 125%;
	padding-right: 8rem;
	display: grid;
	grid-template-rows: 0fr;
	overflow: hidden;
	transition: 0.3s ease-in-out;
	a {
		color: inherit;
		@media (hover: hover) {
			&:hover {
				text-decoration: underline;
			}
		}
	}
	@media (max-width: vars.$xx) {
		padding-right: 2.8rem;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.5rem;
		line-height: 113%;
	}
}

.faq__block {
	position: sticky;
	top: 0;
	display: grid;
	gap: 2rem;
	border-radius: 4.8rem 1.6rem;
	padding: 5rem;
	background: var(--fill-inverse-3);
	z-index: 1;
	p {
		font-size: 2.4rem;
		line-height: 140%;
		color: var(--text-accent-2-100);
		@media (max-width: vars.$x480) {
			font-size: 1.8rem;
		}
	}

	@media (max-width: vars.$m) {
		position: static;
	}
	@media (max-width: vars.$x480) {
		border-radius: 3.2rem 1.6rem;
		padding: 3rem 2.7rem 2rem;
		gap: 2rem;
	}
}
.faq__feedback {
	display: grid;
	gap: 2rem;
	text-align: center;
	@media (max-width: vars.$x480) {
		gap: 10px;
	}
}
.faq__link {
	font-weight: 400;
	font-size: 1.8rem;
	line-height: 111%;
	color: var(--black);
	@media (max-width: vars.$x480) {
		font-size: 1.4rem;
		line-height: 143%;
	}
	a {
		text-decoration: underline;
		color: currentColor;
		@media (hover: hover) {
			&:hover {
				text-decoration: none;
			}
		}
	}
}
</style>
